import React from 'react';
import { Text } from '../Text/Text';

export const _DropDownMenuItem = React.memo(({text, ...props}) => (
	<div {...props} className={`dropdown-item`}>
		<Text text={text} />
	</div>)
);

export const DropDownMenuItem = React.memo(_DropDownMenuItem);